export default __webpack_public_path__ + "static/media/amp_logo.a30c65af.png";